module.exports = __webpack_public_path__ + "talk_to_provider-2cc4a60e8c19db494c8031fbbcca2973.png";